import React, { useEffect } from "react";
import HomePage from "./HomePage";
import SEO from "../components/SEO/SEO";

const ComoFuncionaPage = () => {
  useEffect(() => {
    // Scroll automático a la sección proceso después de cargar la página
    const timer = setTimeout(() => {
      const procesoElement = document.getElementById("proceso");
      if (procesoElement) {
        procesoElement.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 500); // Pequeño delay para asegurar que la página esté cargada

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* SEO específico para "Cómo funciona" */}
      <SEO
        pageType="workflow"
        customTitle="Cómo Funciona Trineo - Proceso Simple en 3 Pasos"
        customDescription="Descubre cómo solicitar fletes con Trineo: 1) Solicita por app o WhatsApp, 2) Elige el mejor transportista, 3) Recibe tu pedido. Proceso rápido y seguro."
      />

      {/* Renderizar la HomePage completa */}
      <HomePage />
    </>
  );
};

export default ComoFuncionaPage;
